import { render } from "./TracedTransactions.vue?vue&type=template&id=1d022f74"
import script from "./TracedTransactions.vue?vue&type=script&lang=js"
export * from "./TracedTransactions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__